import { css } from "@emotion/css";
import { SIZES } from "@view/constants/theme/defaultStyles";

export const styles = {
  search: css({ maxWidth: SIZES.INPUT.MEDIUM.MAX_WIDTH }),
  wrapper: css({
    justifyContent: "space-between",
    marginBottom: 16,
    padding: 16,
  }),
};
